





















import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class BaseViewDetails extends Vue {
  @Prop() sidebarDatapoint!: string;
}
